import { GsFormSchema } from '../../../components';
import { ResponsiveAttribute } from '../../../models/basic/responsive-attribute';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { Mode } from './../basics/swiper.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Default location tiles per view — also the fallback for components saved before the setting existed */
export const APPOINTMENT_CHAIN_STORES_ITEMS_ROW: ResponsiveAttribute<number> = { default: 1.2, md: 2, lg: 3 };
/** Default team member tiles per view — also the fallback for components saved before the setting existed */
export const APPOINTMENT_TEAM_MEMBERS_ITEMS_ROW: ResponsiveAttribute<number> = { default: 1.5, md: 2.5, lg: 3 };
/** Default team member picture height in px, close to the former 3:4 portrait at the default tiles per view */
export const APPOINTMENT_TEAM_MEMBERS_IMAGE_HEIGHT: ResponsiveAttribute<number> = { default: 300, md: 380, lg: 420 };

/** Form schema for the Appointment component settings in the designer. */
export const APPOINTMENT_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    // Same field as DISPLAY_MODE_SCHEMA, but defaulting to the slider — a spread loses the select variant of the union.
    {
      formControlName: 'mode',
      label: 'components.appointment.schema.mode',
      type: 'select',
      valueType: 'number',
      default: Mode.SLIDER,
      options: [
        { text: 'schema.displayMode.grid', value: Mode.GRID },
        { text: 'schema.displayMode.slider', value: Mode.SLIDER }
      ]
    },
    // One setting for both modes: the slider takes decimals to show the next tile cut off, the grid rounds down.
    {
      formControlName: 'chainStoresItemsRow',
      label: 'components.appointment.schema.chainStoresItemsRow.label',
      description: 'components.appointment.schema.chainStoresItemsRow.description',
      type: 'number',
      isResponsive: true,
      default: APPOINTMENT_CHAIN_STORES_ITEMS_ROW,
      min: 1,
      max: 6,
      step: 0.1
    },
    {
      formControlName: 'clampLocationText',
      label: 'components.appointment.schema.clampLocationText',
      type: 'checkbox',
      default: true
    },
    // Defaults to the grid, so topics of existing components keep wrapping onto several lines.
    {
      formControlName: 'categoriesMode',
      label: 'components.appointment.schema.categoriesMode',
      type: 'select',
      valueType: 'number',
      default: Mode.GRID,
      options: [
        { text: 'schema.displayMode.grid', value: Mode.GRID },
        { text: 'schema.displayMode.slider', value: Mode.SLIDER }
      ]
    },
    {
      formControlName: 'teamMembersItemsRow',
      label: 'components.appointment.schema.teamMembersItemsRow.label',
      description: 'components.appointment.schema.teamMembersItemsRow.description',
      type: 'number',
      isResponsive: true,
      default: APPOINTMENT_TEAM_MEMBERS_ITEMS_ROW,
      min: 1,
      max: 6,
      step: 0.1
    },
    {
      formControlName: 'teamMembersImageHeight',
      label: 'components.appointment.schema.teamMembersImageHeight',
      type: 'number',
      isResponsive: true,
      default: APPOINTMENT_TEAM_MEMBERS_IMAGE_HEIGHT,
      min: 50
    },
    {
      formControlName: 'buttons',
      label: 'components.appointment.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
